document.addEventListener('DOMContentLoaded', function() {
    // Utility function to load lazy images
    const loadLazyImages = (container) => {
        const lazyImages = container.querySelectorAll('.mega-menu__icon--lazy[data-src]:not([src])');
        lazyImages.forEach(img => {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            img.classList.remove('mega-menu__icon--lazy');
        });
    };

    const nav = document.querySelector('.custom-mega-menu');
    if (!nav) return;
    const menuItems = nav.querySelectorAll('details');
    const OPEN_DELAY_MS = 250;
    const CLOSE_DELAY_MS = 300; // Slightly longer than open to avoid flicker when switching

    menuItems.forEach((details) => {
        const summary = details.querySelector('summary');
        const level2Items = details.querySelectorAll('.mega-menu__item--level-2');
        const panel = details.querySelector('.mega-menu__panel--level-3');
        const subMenus = panel ? panel.querySelectorAll('.mega-menu__list--level-3') : [];

        const resetMenu = (container) => {
            const items = container.querySelectorAll('.mega-menu__item--level-2');
            const menus = container.querySelectorAll('.mega-menu__list--level-3');
            container.open = false;
            items.forEach(i => i.classList.remove('is-active'));
            menus.forEach(menu => menu.classList.remove('visible'));
        };        

        summary.addEventListener('click', e => e.preventDefault());

        details.addEventListener('mouseenter', () => {
            // Clear any existing timeout for the current details element (could be a close or open timeout for itself)
            clearTimeout(details.dataset.hoverTimeoutId);

            details.dataset.hoverTimeoutId = setTimeout(() => {
                details.open = true; // Open the current menu

                // Now that the current menu is open, close all other menus that might still be open
                menuItems.forEach((other) => {
                    if (other !== details && other.open) {
                        resetMenu(other);
                    }
                });

                // Load images when mega menu opens on hover
                loadLazyImages(nav);
                
                // Set the first level-2 item as active if none is already active
                const currentlyActiveLevel2Item = details.querySelector('.mega-menu__item--level-2.is-active');
                if (!currentlyActiveLevel2Item && level2Items.length) {
                    level2Items.forEach(i => i.classList.remove('is-active'));
                    subMenus.forEach((menu, i) => {
                        menu.classList.toggle('visible', i === 0);
                    });
                    level2Items[0].classList.add('is-active');
                }
            }, OPEN_DELAY_MS);
        });        

        level2Items.forEach((item) => {
            let level2TimeoutId;
            
            item.addEventListener('mouseenter', () => {
                clearTimeout(level2TimeoutId);
                
                level2TimeoutId = setTimeout(() => {
                    const index = item.dataset.index;

                    level2Items.forEach(i => i.classList.remove('is-active'));
                    item.classList.add('is-active');

                    subMenus.forEach((menu) => {
                        menu.classList.toggle('visible', menu.dataset.index === index);
                    });
                }, 150);
            });
            
            item.addEventListener('mouseleave', () => {
                clearTimeout(level2TimeoutId);
            });
        });

        details.addEventListener('mouseleave', () => {
            // Clear any existing timeout for the current details element before setting a new one
            clearTimeout(details.dataset.hoverTimeoutId);
            details.dataset.hoverTimeoutId = setTimeout(() => resetMenu(details), CLOSE_DELAY_MS);
        });        
    });

    // Mobile mega menu functionality
    const mobileNav = document.querySelector('header-drawer');
    if (mobileNav) {
        const mobileMenuDetails = mobileNav.querySelectorAll('details');
        
        mobileMenuDetails.forEach((details) => {
            // Load images when mobile menu details is opened
            details.addEventListener('toggle', () => {
                if (details.open) {
                    loadLazyImages(details);
                }
            });
        });
    }

    // Disable default behavior for links with href="#"
    document.querySelectorAll('a[href="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(event) {
        event.preventDefault();
      });
    });
});
